import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { GripVertical } from "lucide-react";

export function SortableRow({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <div className="flex items-center gap-2">
        <div className="flex-1">{children}</div>
        <button
          type="button"
          {...attributes}
          {...listeners}
          className="cursor-grab text-muted-foreground pt-2"
        >
          <GripVertical className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
